import * as React from 'react'

function IconHexagonCanJoin({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={107}
      viewBox="0 0 104 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g
            filter="url(#filter1_hexagon)"
            strokeMiterlimit={10}
            strokeLinecap="round"
          >
            <path
              d="M77 1H27L2 53.43l25 52.435h50l25-52.434L77 1z"
              fill="#fff"
              stroke={color}
              strokeWidth={2}
            />
            <path
              d="M31.508 98.297l-21.4-44.866 21.4-44.863h40.443l21.4 44.863-21.4 44.866H31.508z"
              fill={color}
              stroke="#fff"
            />
          </g>
          <defs>
            <filter
              id="filter1_hexagon"
              x={0.89209}
              y={0}
              width={102.216}
              height={106.865}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M77 1H27L2 53.43l25 52.435h50l25-52.434L77 1z"
            fill="#fff"
            stroke={color}
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M31.508 98.297l-21.4-44.866 21.4-44.863h40.443l21.4 44.863-21.4 44.866H31.508z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconHexagonCanJoin
